var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_1907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 0C4.99086 0 3.2 1.79086 3.2 4V4.45714C3.2 5.17453 3.41323 5.84213 3.77976 6.4H2.4C1.07452 6.4 0 7.47451 0 8.8V10.4C0 11.7255 1.07452 12.8 2.4 12.8H11.2V6.4H12.8V12.8H21.6C22.9254 12.8 24 11.7255 24 10.4V8.8C24 7.47451 22.9254 6.4 21.6 6.4H20.2203C20.5867 5.84213 20.8 5.17453 20.8 4.45714V4C20.8 1.79086 19.0091 0 16.8 0C14.7629 0 12.9799 1.08767 12 2.71394C11.0201 1.08767 9.23706 0 7.2 0ZM12.8 6.4H17.2571C18.3301 6.4 19.2 5.53016 19.2 4.45714V4C19.2 2.67451 18.1254 1.6 16.8 1.6C14.5909 1.6 12.8 3.39086 12.8 5.6V6.4ZM11.2 6.4H6.74286C5.66984 6.4 4.8 5.53016 4.8 4.45714V4C4.8 2.67451 5.87451 1.6 7.2 1.6C9.40914 1.6 11.2 3.39086 11.2 5.6V6.4Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 14.4H1.59998V20C1.59998 22.2091 3.39084 24 5.59998 24H11.2V14.4Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 24H18.4001C20.6092 24 22.4001 22.2091 22.4001 20V14.4H12.8V24Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_1907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.fa3899245bbaa69811e7ce7cb4e81a7e.svg";
export { ForwardRef as ReactComponent };